import React from "react";
import _ from "lodash";

import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants
} from "shared/components/animations";
const CTOver = ({ winnerPlayer, screens, nonWinner }) => {
  const game_over = _.get(
    screens,
    "6_over.game_over",

    "GAME OVER"
  );
  const win_text = _.get(
    screens,
    "6_over.win_text",

    "The top conspiracist is..."
  );
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="ct-over"
    >
      <motion.h2 variants={fadeVariants} className="title">
        {game_over}
      </motion.h2>
      <motion.h3 variants={fadeVariants} className="sub-title">
        {win_text}
      </motion.h3>
      <motion.div variants={staticBounceVariants} className="player-flex">
        <div className="player-card">
          <img
            src={winnerPlayer?.profile_image}
            className="img-fluid profile"
            alt="profile"
          />
          <p className="name">{winnerPlayer?.display_name}</p>
        </div>
      </motion.div>

      <div className="player-flex">
        {nonWinner?.map((value, index) => (
          <motion.div variants={staticBounceVariants} className="player-card">
            <img
              src={value?.profile_image}
              className="img-fluid profile"
              alt="profile"
            />
            <p className="name">{value?.display_name}</p>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default CTOver;
